import { Component, InjectionToken, inject, input, ChangeDetectionStrategy } from '@angular/core';
import type { FormControl, FormGroup } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  BoxComponent,
  HeadingComponent,
  ProtectedControlDirective,
} from '@core/user-interface-legacy';

import { WorkModelItemComponent } from './work-model-item/work-model-item.component';

export interface WorkModelSectionTranslations {
  heading: string;
  subheading: string;
}

export enum WorkModelSectionViewContext {
  Requisition = 'requisition',
  Job = 'job',
}

export const WorkModelSectionTranslationsToken = new InjectionToken<WorkModelSectionTranslations>(
  'WorkModelSectionTranslations',
);

@Component({
  selector: 'rt-work-model-section',
  templateUrl: './work-model-section.component.html',
  styleUrls: ['./work-model-section.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    BoxComponent,
    HeadingComponent,
    WorkModelItemComponent,
    ProtectedControlDirective,
  ],
})
export class WorkModelSectionComponent {
  public readonly translations = inject<WorkModelSectionTranslations>(
    WorkModelSectionTranslationsToken,
  );

  public readonly WorkModelSectionViewContext = WorkModelSectionViewContext;

  public readonly workModelControl = input<FormGroup>(undefined!);
  public readonly readOnly = input<boolean>(undefined!);
  public readonly viewContext = input<WorkModelSectionViewContext>(undefined!);
  public readonly hideWorkModelRequiredBadge = input(false);

  public get showRequiredBadge(): boolean {
    return (
      !this.onSiteControl.value &&
      !this.remoteControl.value &&
      !this.hybridControl.value &&
      !this.hideWorkModelRequiredBadge()
    );
  }

  public get showInvalid() {
    const workModelControl = this.workModelControl();
    return workModelControl.errors?.workModel && workModelControl.touched;
  }

  public get onSiteControl() {
    return <FormControl>this.workModelControl().get('onSite')!;
  }

  public get remoteControl() {
    return <FormControl>this.workModelControl().get('remote')!;
  }

  public get hybridControl() {
    return <FormControl>this.workModelControl().get('hybrid')!;
  }

  public select(control: FormControl) {
    const currentValue = control.value;
    control.setValue(!currentValue);
    control.markAsTouched();
    control.markAsDirty();
  }
}
